import { module as BaseModule } from 'modujs'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class extends BaseModule {
  constructor(m) {
    super(m)

    this.$items = this.$('item')
  }

  init() {
    this.$items.forEach((item) => {
      const inner = item.querySelector('.c-home__projects__item__inner')

      const tl = gsap.timeline({
      })
        .from(inner, {
          y: 'random(150, 500)',
          duration: 0.2,
        }, 'start')

      ScrollTrigger.create({
        trigger: item,
        start: 'top bottom+=20%',
        end: 'bottom bottom-=40%',
        animation: tl,
        scrub: 1,
      })
    })
  }
}
